import React from 'react';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { LazyMessagesProvider } from './lazy-messages-provider';
export var MessagesProvider = function MessagesProvider(_ref) {
  var children = _ref.children;
  if (getBooleanFF('platform.linking-platform.link-picker.lazy-intl-messages')) {
    return /*#__PURE__*/React.createElement(LazyMessagesProvider, null, children);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};